import { loadArticle } from '../../helper/externalApi'
import { Article } from '../../helper/interfaces'
import React, { useState, useContext, useEffect } from 'react'
import { nextBasicAuthCheck } from '../../helper/basicAuthHelper'

import { useRouter } from "next/router";
import ArticleComponent from '../../components/ArticleComponent'
import Piano from '../../components/Piano';
import Breadcrumbs from '../../components/Breadcrumbs';
import Tracking from '../../components/Tracking';
import Seo from '../../components/Seo';
import Og from '../../components/Og';
import { PageContent } from '../../components/shared/PageContent';
import { AppContext } from '../../provider/AppContextProvider';
import { NoContent } from '../../components/shared/NoContent';
import { useLoggedRouter } from '../../helper/useLoggedRouter';
import { getHashParameter, scrollToArticle } from '../../helper/hashHelper';
import Traffective from '../../components/Traffective';
import AffiliateWidgets from '../../components/AffiliateWidgets';

declare global {
    interface Window {
    refreshBids: Function;
  }
}
interface Data {
  entry: Article | null,
  id: string
}

function Index(data: Data) {
  const router = useRouter();
  const { subscription, debugLog, appInfo } = useContext(AppContext)
  const isIos = appInfo?.platform === "ios";

  const [showOffer, setShowOffer] = useState(false)

  // useEffect(() => {
  //   if(data.entry.seoUrl) {
  //     router.replace(
  //       {
  //         pathname: `/article/[id]`,
  //         query: {
  //           id: data.id,
  //         },
  //       },
  //       `/${data.entry.seoUrl.ressort}/${data.entry.seoUrl.id}`,
  //       {shallow: true,}
  //     );
  //   }
  // })
  
  const article = data.entry
  const [routerPush, routerReplace] = useLoggedRouter();

  const navigate = async (id?: string, ressortId?: string, linkUrl?: string) => {
    //store scroll position
    if (article?.id) {
      await routerReplace(`/article/${article.id}#a=${id}`, true);
    }

    if (id) {
      await routerPush(`/article/${id}`, false);
    } else if (linkUrl) {
      await routerPush(linkUrl, false);
    } else if (ressortId) {
      await routerPush(`/ressort/${ressortId}`, false);
    }
  };

  const handleParams = async (hashParams) => {
    if (hashParams.articleId) {
      scrollToArticle(hashParams.articleId, debugLog, isIos);
    }
  }

  useEffect(() => {
    (window as any).appScroll = () => {
      const hashParams = getHashParameter(window.location.hash);
      handleParams(hashParams)
      //restoreScroll(article?.id, 'article');
    }
  }, []);

  useEffect(() => {
    const hashParams = getHashParameter(window.location.hash);
    handleParams(hashParams)
  }, [
    article?.id
  ]);

  // const { } = useScrollRestoration(
  //   article?.id ? `article-${article?.id}` : 'default-article',
  //   'article',
  //   {
  //     debounceTime: 200
  //   },
  //   debugLog
  // );

  return (
    (article && article.status == 200) ?
      <React.Fragment>
        {article.pageInformation?.trackingInformation && <Tracking trackingInformation={article.pageInformation.trackingInformation} />}
        {article.pageInformation?.adInformation && <Traffective
          adInformation={article.pageInformation.adInformation}
        />}
        {article.adIdentifier == true && <AffiliateWidgets />}
        {article.pageInformation?.seoItems && <Seo items={article.pageInformation.seoItems} />}
        {article.pageInformation?.ogItems && <Og items={article.pageInformation.ogItems} />}
          <React.Fragment>
            {article.pageInformation?.breadcrumbs && <Breadcrumbs breadcrumbs={article.pageInformation.breadcrumbs} navigate={navigate}/>}
            {article.pageInformation?.pianoSwitchConfiguration && <Piano article={article} showOffer={showOffer} trackingInformation={article.pageInformation.trackingInformation} pianoSwitchConfiguration={article.pageInformation.pianoSwitchConfiguration}/>}
            <PageContent>
              <ArticleComponent entry={article} contentBlocked={!(subscription.nnPlusApp || subscription.nnPlusWeb) && article.paid == true && !(article.pageInformation?.pianoSwitchConfiguration?.paywallOff ?? true)} showPianoOffer={() => { setShowOffer(true) }} navigate={navigate} />
            </PageContent>
          </React.Fragment>
      </React.Fragment>
      :
      <NoContent status={article?.status.toString()} />
  )
}


export async function getServerSideProps(context) {
  const { req, res } = context
  await nextBasicAuthCheck(req, res)

  const { id } = context.query;

  let result: Article | null = await loadArticle(id);

  return { props: { entry: result } };
}

export default Index
